export enum EPrivileges {
  CanEditWorkspace = "workspace.edit",
  CanEditWorkspaceStructure = "workspace.structure.edit",
  CanViewWorkspaceStructure = "workspace.structure.view",
  CanInviteMembersToWorkspace = "workspace.members.invite",
  CanEditMembersInWorkspace = "workspace.members.edit",
  CanEditRole = "workspace.role.edit",
  CanViewRoles = "workspace.role.view",
  canTaskAssign = "workspace.task.assign",
  /**
   * Upoważnienie do obsługi przesyłek poufnych (bezpiecznej koperty) W IMIENIU podmiotu.
   * Osoba prawna sama nic nie wyśle, więc właściciel wskazuje nim konkretne osoby z zespołu.
   * BE: WorkspacePrivileges.CreateParcelsForOthers.
   */
  canCreateParcelsForOthers = "workspace.parcel.createForOthers",
  /** BE: WorkspacePrivileges.EditTags. Nieegzekwowane — edycję etykiet bramkuje dziś EditMembers. */
  CanEditTags = "workspace.tags.edit",
  /** BE: WorkspacePrivileges.EditStatuses. Nieegzekwowane — edycję statusów bramkuje dziś EditMembers. */
  CanEditStatuses = "workspace.statuses.edit",
  /** BE: WorkspacePrivileges.ViewPayments. Nieegzekwowane — brak wywołań. */
  CanViewPayments = "workspace.payments.view",
  CanManagePayments = "workspace.payments.manage",
  /** BE: WorkspacePrivileges.ViewInvoices. Nieegzekwowane — brak wywołań. */
  CanViewInvoices = "workspace.invoices.view",

  // ── Model kluczy firmowych, Faza 1 (docs/model-kluczy-firmowych.md) ──────────────────
  // 15 nowych wartości. W F1 CAŁKOWICIE BEZCZYNNE: można je nadać w edytorze ról, ale
  // żadna ścieżka BE ich nie sprawdza — bramkami dostępu do treści stają się w F7.
  // Stringi są kontraktem z BE (Kwantum.LegalMail.Data/Workspace/WorkspacePrivileges.cs)
  // i NIE WOLNO ich zmieniać.

  /** Korespondencja: przesyłki, poczta, portal sądowy, czaty, formularz kontaktowy. */
  CanReadCorrespondence = "data.correspondence.read",
  /** Korespondencja: tworzenie, edycja i wysyłka przesyłek oraz wiadomości. */
  CanWriteCorrespondence = "data.correspondence.write",
  /** Sprawy: sprawy, teczki, dysk teczki, notatki i dokumenty w teczce. */
  CanReadCases = "data.cases.read",
  /** Sprawy: zakładanie i edycja spraw, teczek, dokumentów i notatek. */
  CanWriteCases = "data.cases.write",
  /** Rejestry: repertoria, rejestr umów i faktur, KSeF, księgowość, budżet. */
  CanReadRegisters = "data.registers.read",
  /** Rejestry: wpisy i korekty w repertoriach, rejestrach, księgowości i budżecie. */
  CanWriteRegisters = "data.registers.write",
  /** Czynności: zadania i kalendarz, czynności notarialne, akty w przygotowaniu, podpisy. */
  CanReadActivities = "data.activities.read",
  /** Czynności: zakładanie i edycja zadań, zdarzeń kalendarza i aktów w przygotowaniu. */
  CanWriteActivities = "data.activities.write",
  /** Kartoteka: klienci, kontrahenci, książka adresowa, podmioty, AML. */
  CanReadRecords = "data.records.read",
  /** Kartoteka: zakładanie i edycja podmiotów, kontrahentów i kart AML. */
  CanWriteRecords = "data.records.write",
  /** Trwałe usuwanie danych firmy (kosz opróżniany na stałe, purge obiektu). */
  CanDeleteData = "data.delete",
  /** Dekretacja / przekazywanie obiektów innym członkom firmy. */
  CanAssignData = "data.assign",
  /** Eksport danych poza system (paczki archiwalne, pobranie masowe). */
  CanExportData = "data.export",
  /** Zarządzanie integracjami firmy (poczta, bank, portal sądowy, KSeF, ePUAP). */
  CanManageIntegrations = "workspace.integrations.manage",
  /** Wydawanie klucza firmy nowym członkom (WorkspaceKeyGrants). Q21: ma je Administrator. */
  CanGrantCompanyKeys = "workspace.keys.grant",
}
